import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import PointActivityService from "service/PointActivity";

export const getAllPointActivities =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterPointType: string = ""
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_POINT_ACTIVITY_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_POINT_ACTIVITY",
      searchValue: search,
    });

    try {
      const data = await PointActivityService.getPointActivities(
        page,
        search,
        limit,
        filterPointType
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_POINT_ACTIVITY", value: data.point_activities });
      dispatch({
        type: "SET_POINT_ACTIVITY_PAGE",
        totalPage: !!data.point_activities.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.point_activities.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_POINT_ACTIVITY_FILTER_PAGE",
        filterPointTypePage: filterPointType,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };
